import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isScroll: false,
    contentNewsSetting: 0,//新闻资讯
    contentColumnSetting: 0,//栏目管理
    homeChartSetting:0,
    supDemandSetting:0,
    supplyMessageSetting:0,
    workProcesseSetting:0,
    consultSetting:0,
    platformSetting:0,
    cargoInfoSetting: 0,
    productInfoSetting: 0,//产品管理
    microAPPSetting: 0,//app管理
    planManageSetting: 0,//方案管理
    caseManageSetting: 0,//案例管理
    tenantManagSetting: 0,//用户中心
    transactionOrderSetting: 0,//交易订单
    systemSettings: 0,//系统管理

  },
  getters: {
    scrollget(state) {
      return state.isScroll
    }
  },
  mutations: {
    scrollSet(state, playload) {
      state.isScroll = playload;
    },
    contentNewsSet(state, payload) {
      state.contentNewsSetting = payload;
    },
    supDemandSet(state, payload) {
      state.supDemandSetting = payload;
    },
    supplyMessageSet(state, payload) {
      state.supplyMessageSetting = payload;
    },
    consultSet(state, payload) {
      state.consultSetting = payload;
    },
    homeChartSet(state, payload) {
      state.homeChartSetting = payload;
    },
    workProcesseSet(state, payload) {
      state.workProcesseSetting = payload;
    },
    platformSet(state, payload) {
      state.platformSetting = payload;
    },
    productInfoSet(state, payload) {
      state.productInfoSetting = payload;
    },
    contentColumnSet(state, payload) {
      state.contentColumnSetting = payload;
    },
    cargoInfoUpdate(state, payload) {
      state.cargoInfoSetting = payload;
    },
    cargoInfoDelete(state, payload) {
      state.cargoInfoSetting = payload;
    },
    microAPPSet(state, payload) {
      state.microAPPSetting = payload;
    },
    planManageSet(state, payload) {
      state.planManageSetting = payload;
    },
    caseManageSet(state, payload) {
      state.caseManageSetting = payload;
    },
    tenantManagSet(state, payload) {
      state.tenantManagSetting = payload;
    },
    transactionOrderSet(state, payload) {
      state.transactionOrderSetting = payload;
    },
    systemSet(state, payload) {
      state.systemSettings = payload;
    },
  },
  actions: {
    setInfo(context, val) {
      context.commit('WAYBILLSET', val)
    }
  },
  modules: {}

})
